import { useSelector } from 'core/common/hooks';
import { getIsMobileDevice, getPlatform } from 'core/common/store';

export const useSystem = () => {
  const isMobileDevice = useSelector(getIsMobileDevice);
  const platform = useSelector(getPlatform);

  return {
    isMobileDevice,
    platform,
  };
};
